import { RoleSelection } from "@/features/auth/components/RoleSelection";
import { AuthLayout } from "@/features/layout/AuthLayout";

const SignUpPage = () => {
  return <RoleSelection />;
};

export default SignUpPage;

SignUpPage.getLayout = function getLayout(page) {
  return <AuthLayout hasFooter>{page}</AuthLayout>;
};
